// types
import { Account, Contract, Entity, Project, Transaction, User } from '../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// mui
import { Avatar, Box, Tooltip, Typography } from '@mui/material';

// ui
import { Time } from '../Time/Time';
import { UserAvatar } from '../UserAvatar/UserAvatar';

// props
export interface UserAvatarModifiedProps {
	account?: Account;
	contract?: Contract;
	date?: string;
	entity?: Entity;
	hasCreatedFallback?: boolean;
	project?: Project;
	transaction?: Transaction;
	user?: Partial<User> | null;
	variant?: 'compact' | 'normal';
}

export const UserAvatarModified = ({
	account,
	contract,
	date,
	entity,
	hasCreatedFallback = false,
	project,
	transaction,
	user,
	variant = 'normal',
}: UserAvatarModifiedProps) => {
	// hooks
	const { t } = useTranslation();

	let actorUser = user;
	let displayDate = date;

	// Get resource and validate
	const resource = transaction || contract || entity || account || project || user;

	if (resource && !displayDate && hasCreatedFallback) {
		displayDate = (resource as { created?: string })?.created;
	}

	if (displayDate) {
		const time = <Time date={new Date(displayDate)} TypographyProps={{ variant: 'caption' }} />;

		if (variant === 'compact') {
			return (
				<Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
					<Tooltip placement="top" title={actorUser?.firstName || t('na')}>
						<Avatar
							sx={{
								width: 20,
								height: 20,
							}}
						/>
					</Tooltip>
					<Typography
						variant="caption"
						sx={{
							whiteSpace: 'nowrap',
							overflow: 'hidden',
							textOverflow: 'ellipsis',
							maxWidth: '120px',
						}}>
						{time}
					</Typography>
				</Box>
			);
		}

		return (
			<UserAvatar
				user={actorUser || null}
				caption={{
					children: time,
				}}
			/>
		);
	}

	return <Typography variant={variant === 'compact' ? 'caption' : 'body1'}>{t('na')}</Typography>;
};
